var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fx-select" }, [
    _vm.isMobileDevice && !_vm.disableNative
      ? _c("div", { staticClass: "fx-select-native" }, [
          !_vm.defaultOption && _vm.options.length === 1
            ? _c("span", { staticClass: "fx-selection" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.options[0].label) +
                    " " +
                    _vm._s(_vm.options[0].all_in_price) +
                    "\n        "
                )
              ])
            : _c("div", [
                _c(
                  "select",
                  {
                    attrs: {
                      "aria-label": _vm.ariaLabel,
                      disabled: _vm.disabled,
                      required: _vm.required
                    },
                    domProps: {
                      value: _vm.selection ? _vm.selection.value : null
                    },
                    on: { change: _vm.onNativeSelectChange }
                  },
                  [
                    _vm.defaultOption
                      ? _c(
                          "option",
                          { domProps: { value: _vm.defaultOption.value } },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.defaultOption.label) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(option.label) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.selection.all_in_price
                  ? _c(
                      "span",
                      { staticClass: "fx-select-native__all-in-price" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.selection.all_in_price) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isMobileDevice || _vm.disableNative
      ? _c(
          "div",
          {
            directives: [
              {
                name: "on-click-outside",
                rawName: "v-on-click-outside.static",
                value: _vm.close,
                expression: "close",
                modifiers: { static: true }
              }
            ],
            staticClass: "fx-select-custom",
            class: { disabled: _vm.disabled, selectable: _vm.isSelectable },
            attrs: { "aria-label": _vm.ariaLabel }
          },
          [
            _c(
              "div",
              {
                ref: "selectInput",
                staticClass: "fx-select-input",
                class: { open: _vm.isDropdownOpen },
                attrs: { "data-index": "0", tabindex: "0" },
                on: {
                  click: _vm.onCustomSelectClick,
                  keydown: [
                    function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onCustomSelectClick($event)
                    },
                    function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      _vm.setFocus(1)
                    }
                  ]
                }
              },
              [
                _vm.selection
                  ? _c("span", { staticClass: "fx-selection" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.selection.label) +
                          " " +
                          _vm._s(_vm.selection.all_in_price) +
                          "\n            "
                      )
                    ])
                  : _c("span", { staticClass: "fx-placeholder" }, [
                      _vm._v(_vm._s(_vm.placeholder))
                    ]),
                _vm._v(" "),
                _vm.isSelectable && (!_vm.value || !_vm.defaultOption)
                  ? _vm._t("caret", [
                      _c("span", { staticClass: "icon-caret-down" })
                    ])
                  : _vm.isSelectable && _vm.value
                  ? _c("span", {
                      staticClass: "icon-cancel",
                      attrs: { "aria-label": "clear selection", tabindex: "0" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.clear($event)
                        },
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.stopPropagation()
                          return _vm.clear($event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isDropdownOpen && _vm.isSelectable,
                    expression: "isDropdownOpen && isSelectable"
                  }
                ],
                ref: "dropdown",
                staticClass: "fx-select-dropdown",
                class: {
                  left: _vm.align === "left",
                  right: _vm.align === "right"
                },
                style: { "max-height": _vm.maxDropDownHeight + "px" }
              },
              [
                _c(
                  "ul",
                  { ref: "selectOptions", staticClass: "fx-list" },
                  [
                    _vm.defaultOption
                      ? _c(
                          "li",
                          {
                            class: {
                              selected: _vm.defaultOption === _vm.selection
                            },
                            attrs: { "data-index": "1", tabindex: "0" },
                            on: {
                              click: function($event) {
                                _vm.select(_vm.defaultOption.value)
                                _vm.setFocus(0)
                              },
                              keydown: [
                                function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  _vm.select(_vm.defaultOption.value)
                                  _vm.setFocus(0)
                                },
                                function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "up",
                                      38,
                                      $event.key,
                                      ["Up", "ArrowUp"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.setFocus(0)
                                },
                                function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "down",
                                      40,
                                      $event.key,
                                      ["Down", "ArrowDown"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.setFocus(2)
                                }
                              ]
                            }
                          },
                          [
                            _c("span", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.defaultOption === _vm.selection,
                                  expression: "defaultOption === selection"
                                }
                              ],
                              staticClass: "icon-checkmark"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fx-option-label" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.defaultOption.label) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "li",
                        {
                          key: option.value,
                          class: { selected: option === _vm.selection },
                          attrs: {
                            "data-index": _vm.defaultOption
                              ? index + 2
                              : index + 1,
                            tabindex: "0"
                          },
                          on: {
                            click: function($event) {
                              _vm.select(option.value)
                              _vm.setFocus(0)
                            },
                            keydown: [
                              function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.select(option.value)
                                _vm.setFocus(0)
                              },
                              function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp"
                                  ])
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                _vm.setFocus(
                                  _vm.defaultOption ? index + 1 : index
                                )
                              },
                              function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                _vm.setFocus(
                                  _vm.defaultOption ? index + 3 : index + 2
                                )
                              }
                            ]
                          }
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: option === _vm.selection,
                                expression: "option === selection"
                              }
                            ],
                            staticClass: "icon-checkmark"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "fx-option-label" }, [
                            _vm._v(_vm._s(option.label))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }